<template>
  <div class="container has-text-centered">
    <div class="column is-4 is-offset-4 content is-small">
      <b-field>
        <img src="/logo.png" class="logo"/>
      </b-field>
      <h1>
        {{ $t('message.title') }}
      </h1>
      <h2>
        {{ $t('message.enterpriseCode') }}
      </h2>
      <Keyboard @onSubmit="onCieSubmit"></Keyboard>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import toaster from './toaster'
import Keyboard from "@/Keyboard";

export default {
  components: {
    Keyboard
  },
  mounted() {
    var code = localStorage.getItem('cie_code') || ''
    if (code) {
      this.onCieSubmit(code)
    }
  },
  methods: {
    onCieSubmit(code, callback) {
      return axios.post('/api/v1/cie/info', {code: code}).then(res => {
        const cieInfo = res.data
        cieInfo.code = code
        localStorage.setItem('cie_code', cieInfo.code)
        this.$emit('updateCie')
        localStorage.setItem('cie_lang', cieInfo.cie.defaultLang)
        this.$i18n.locale = cieInfo.cie.defaultLang
        this.$router.push({path: '/ui/hr'})
      }).catch(toaster.catch(this)).finally(() => {
        callback();
      })
    }
  }
}
</script>
